<template>
  <div class="nullImage_wrap" v-if="isShowNullImage">
    <p class="nullImage_wrap_style"><img :src="nullImage" alt="" class="nullImage_style"></p>
    <span class="nullImage_text">{{nullText}}</span>
  </div>
</template>

<script  type="text/ecmascript-6">
export default {
  name: 'nullImage',
  props: {
    nullText: {
      type: String,
      default: '收藏夹空空如也～'
    },
    nullImage: {
      type: String,
      default: require('../assets/null_img.png')
    },
    isShowNullImage: {
      type: Boolean,
      default: false
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>
<style lang="scss">
@import './../scss/mixin.scss';
.nullImage_wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: $rem294;
}
.nullImage_style {
  width: 100%;
  height: auto;
}
.nullImage_wrap_style {
  width: $rem380;
  height: $rem238;
  overflow: hidden;
  margin-bottom: $rem80;
}
.nullImage_text {
  font-family: PingFangSC-Regular;
  font-size: $rem28;
  color: #283039;
  letter-spacing: 0;
  text-align: center;
  line-height: $rem40;
}
</style>

